// Components
// Libs
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

// API
import patchNotifications from '@/common/api/notifications/patchNotifications';
import Snack from '@/common/components/molecules/Snack/Snack';

const useManageNotifications = ({ disabled, isLoading }) => {
  const { t } = useTranslation();

  const {
    mutate: mutatePatchNotifications,
    isLoading: isLoadingPatchNotifications,
  } = useMutation(patchNotifications);

  const onUpdateNotifications = useCallback(
    ({ values, onSuccess = () => {} }) => {
      mutatePatchNotifications(
        {
          type: values.type,
          notificationIds: values.notificationIds,
        },
        {
          onSuccess: () => {
            onSuccess();

            toast.success(
              <Snack message={t('common:messages:forms.success.default')} />,
            );
          },
          onError: (error) => {
            if (error.response.status === 500) {
              toast.error(
                <Snack
                  message={t('common:messages:forms.errors.server_error')}
                />,
              );
            } else {
              toast.error(
                <Snack message={t('common:messages:forms.errors.default')} />,
              );
            }
          },
        },
      );
    },
    [mutatePatchNotifications, t],
  );

  const isDisabled = useMemo(() => {
    const loading = isLoading || isLoadingPatchNotifications;

    return {
      loading: isLoading || isLoadingPatchNotifications,
      disabled: loading || disabled,
    };
  }, [disabled, isLoading, isLoadingPatchNotifications]);

  return {
    isDisabled,
    onUpdateNotifications,
  };
};

export default useManageNotifications;
